<template>
  <v-dialog
    v-model="active"
    width="80%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Evaluacion validación
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="evaluacionValidacion">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Evaluado"
                :value="getFullName(
                  evaluacionValidacion.Derivacion.Programacion.Expediente.Personal)"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Fecha elaboración"
                :value="evaluacionValidacion.fechaElaboracion"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Fecha evaluación"
                :value="evaluacionValidacion.fechaEvaluacion"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Fecha oficio"
                :value="evaluacionValidacion.fechaOficio"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-text-field
                label="Matrícula cartilla"
                :value="evaluacionValidacion.matriculaCartilla"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
              <v-text-field
                label="Oficio validación"
                :value="evaluacionValidacion.oficioValidacion"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="5">
              <v-textarea
                label="Observaciones"
                :value="evaluacionValidacion.observaciones"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="4"
              />
            </v-col>
            <v-col cols="5">
              <v-textarea
                label="Resultado"
                :value="evaluacionValidacion.resultado"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="4"
              />
            </v-col>
            <v-col cols="3">
              <v-card
                class="card"
                color="primary"
              >
                <v-card-text>
                  <v-btn
                    text
                    color="secondary"
                    block
                    @click="download(evaluacionValidacion.URL)"
                  >
                    <v-icon class="pr-2">
                      mdi-file-download
                    </v-icon>
                    Oficio validación
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="text-h6">
                Registro de informe en alcance
              </div>
            </v-col>
            <v-row>
              <v-col>
                <v-text-field
                  label="Fecha de oficio de solicitud"
                  :value="evaluacionValidacion.Derivacion.fechaOficioSolicitud"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col>
                <v-text-field
                  label="Número de oficio de solicitud"
                  :value="evaluacionValidacion.Derivacion.oficioSolicitud"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col>
                <v-text-field
                  label="Fecha de oficio de respuesta"
                  :value="evaluacionValidacion.Derivacion.fechaOficioRespuesta"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col>
                <v-text-field
                  label="Número de oficio de respuesta"
                  :value="evaluacionValidacion.Derivacion.oficioRespuesta"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col cols="3">
                <v-card
                  class="card"
                  color="primary"
                >
                  <v-card-text>
                    <v-btn
                      text
                      color="secondary"
                      block
                      @click="download(evaluacionValidacion.Derivacion.URLOficioRespuesta)"
                    >
                      <v-icon class="pr-2">
                        mdi-file-download
                      </v-icon>
                      Oficio respuesta
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Observaciones"
                  :value="evaluacionValidacion.Derivacion.observaciones"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  no-resize
                  rows="4"
                />
              </v-col>
            </v-row>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionValidacion: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
